"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var adapters_superagent_1 = require("@leancloud/adapters-superagent");
exports.request = adapters_superagent_1.request;
exports.upload = adapters_superagent_1.upload;
exports.storage = window.localStorage;
exports.WebSocket = window.WebSocket;
exports.platformInfo = {
    name: "Browser",
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@leancloud/platform-adapters-browser/lib/index.js
// module id = qkhE
// module chunks = 0